import type { ArtMetadata } from "./art-metadata";

export function metadataToJson(metadata: ArtMetadata) {
  return JSON.stringify(metadata, (key, value) => {
    if (key === "rotation" && value === 0) return undefined;
    if (key === "scale" && value === 100) return undefined;
    return value;
  }, 2);
}
